export const PHONE_CODES = [
  { code: '+91', label: 'India +91' },
  { code: '+1', label: 'US/Canada +1' },
  { code: '+44', label: 'UK +44' },
  { code: '+61', label: 'Australia +61' },
  { code: '+971', label: 'UAE +971' },
  { code: '+65', label: 'Singapore +65' },
  { code: '+49', label: 'Germany +49' },
  { code: '+33', label: 'France +33' },
  { code: '+81', label: 'Japan +81' },
  { code: '+86', label: 'China +86' },
  { code: '+977', label: 'Nepal +977' },
  { code: '+94', label: 'Sri Lanka +94' },
  { code: '+880', label: 'Bangladesh +880' },
  { code: '+966', label: 'Saudi Arabia +966' },
  { code: '+60', label: 'Malaysia +60' }
]

export function splitPhone(phone) {
  const value = String(phone || '')
  const match = [...PHONE_CODES].sort((a, b) => b.code.length - a.code.length)
    .find((item) => value.startsWith(item.code))
  if (!match) {
    return { phone_country: '+91', phone_number: value.replace(/\D/g, '') }
  }
  return {
    phone_country: match.code,
    phone_number: value.slice(match.code.length)
  }
}

export function combinePhone(country, number) {
  const local = String(number || '').replace(/\D/g, '')
  const code = String(country || '').replace(/\D/g, '')
  if (!local) return ''
  return `+${code}${local}`
}
